// BuildingVisualInspectionModal.js
import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import BuildingOwnershipInfoComponent from "./buildingOwnershipInfoComponent";
import { BuildingDTO } from "shared/types/building";
import { useMemo } from "react";

const BuildingOwnershipInfoModal = ({ isOpen, onClose, building, unit }: any) => {
  const memoizedBuilding = useMemo(() => building, [building?.id]);
  const memoizedUnit = useMemo(() => unit, [unit?.id]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      shouldBlockScroll={true}
      isDismissable={true}
      scrollBehavior="inside"
      backdrop="blur"
      className="p-8"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <p>{unit?.id || building?.id} - Eigendomsinformatie</p>
        </ModalHeader>
        <ModalBody className="px-0">
          <BuildingOwnershipInfoComponent
            ownershipInfo={{ ...(building as BuildingDTO)?.buildingOwnershipInfo as any, buildingId: building?.id}}
            handleCloseParent={onClose}
            incomingBuilding={memoizedBuilding}
            incomingUnit={memoizedUnit}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default BuildingOwnershipInfoModal;
